<div class="photo-viewer">
  <div class="photo-viewer-container">
    <div class="viewer">
      <div class="close" (click)="hideModel.emit()">
        <i class="fa fa-times"></i>
      </div>
      <img src="{{ url }}" alt="">
    </div>
  </div>
</div>